<template>
  <div>
    <div class="textF">{{ Text }}</div>
    <div class="valueF">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    Text: String,
    value: String,
  },
};
</script>
<style scoped>
.textF {
  color: rgb(94, 94, 94);
  font-size: 0.7rem;
}
.valueF {
  color: #000;
  font-size: 0.9rem;
  padding: 3px 0px;
}
</style>